import Vue from 'vue';
import VueRouter from 'vue-router';
import pages from '@/enums/pages.json';
import Menu from '@/components/menu/Menu.vue';
import Rules from '@/components/rules/Rules.vue';
import GameTable from '@/components/game-table/GameTable.vue';

Vue.use(VueRouter);

const mainMenuConfig = {
  component: Menu,
  props: () => ({
    path: pages.menu,
    menuItems: [
      { label: 'Színek, képek', link: `/${pages.menu_colors}` },
      { label: 'Betűk', link: `/${pages.menu_letters}` },
      { label: 'Számok', link: `/${pages.menu_numbers}` },
      { label: 'Szabályok', link: `/${pages.rules}` }
    ]
  })
};

const colorGamesConfig = {
  component: Menu,
  props: () => ({
    path: pages.menu_colors,
    navigationRoute: 'showColorGames',
    menuItems: [
      { label: 'Állatos memory', link: '/game?type=animals' },
      { label: 'Szín memory kicsiknek', link: '/game?type=simpleTiles' },
      { label: 'Színek és szavak 1. (alapfok)', link: '/game?type=tilesAndColorLables' },
      { label: 'Színek és szavak 2. (haladó)', link: '/game?type=tilesAndBlackLabels' },
      { label: 'Színek és szavak 3. (extra nehéz)', link: '/game?type=tilesAndOtherLabels' }
    ]
  })
};

const letterGamesConfig = {
  component: Menu,
  props: () => ({
    path: pages.menu_letters,
    navigationRoute: 'showLetterGames',
    menuItems: [
      { label: 'Állatos ábécé', link: '/game?type=animalABC' },
      { label: 'Nyomtatott kicsik', link: '/game?type=letters1' },
      { label: 'Nyomtatott kicsik / írott kicsik', link: '/game?type=letters2' },
      { label: 'Nyomtatott kicsik / nyomtatott nagyok', link: '/game?type=letters3' },
      { label: 'Nyomtatott nagyok / írott nagyok', link: '/game?type=letters4' },
      { label: 'Írott kicsik / írott nagyok', link: '/game?type=letters5' },
      { label: 'Betű típusa szerint vegyes', link: '/game?type=letters6' }
    ]
  })
};

const numberGamesConfig = {
  component: Menu,
  props: () => ({
    path: pages.menu_numbers,
    navigationRoute: 'showNumberGames',
    menuItems: [
      { label: 'Szorzótáblás játékok', link: `/${pages.menu_numbers_multipliers}` },
      { label: 'Játék a számokkal (kicsiknek is)', link: `/${pages.menu_figures}` }
      // { label: 'Játék az arab számokkal', link: '/multiplier-games' },
      // { label: 'Játék a római számokkal', link: '/multiplier-games' },
      // { label: 'Játék az arab és római számokkal', link: '/multiplier-games' },
      // { label: 'Extra kihívás (arab és római számok 2000-ig)', link: '/multiplier-games' }
    ]
  })
};

const multiplierGamesConfig = {
  component: Menu,
  props: () => ({
    path: pages.menu_numbers_multipliers,
    navigationRoute: 'showMultiplierGames',
    fromRoute: pages.menu_numbers,
    menuItems: [
      { label: '2-es szorzótábla', link: '/game?type=multiplies2' },
      { label: '10-es szorzótábla', link: '/game?type=multiplies10' },
      { label: '3-as szorzótábla', link: '/game?type=multiplies3' },
      { label: '4-es szorzótábla', link: '/game?type=multiplies4' },
      { label: '2-es és 4-es szorzótábla', link: '/game?type=multiplies2and4' },
      { label: '5-ös szorzótábla', link: '/game?type=multiplies5' },
      { label: '5-ös és 10-es szorzótábla', link: '/game?type=multiplies5and10' },
      { label: '6-os szorzótábla', link: '/game?type=multiplies6' },
      { label: '2, 3, 6-os szorzótábla', link: '/game?type=multiplies2and3and6' },
      { label: '7-es szorzótábla', link: '/game?type=multiplies7' },
      { label: '8-as szorzótábla', link: '/game?type=multiplies8' },
      { label: '2, 4, 8-as szorzótábla', link: '/game?type=multiplies2and4and8' },
      { label: '3-as és 4-es szorzótábla', link: '/game?type=multiplies3and4' },
      { label: '9-es szorzótábla', link: '/game?type=multiplies9' },
      { label: '3, 6, 9-es szorzótábla', link: '/game?type=multiplies3and6an9' }
    ]
  })
};

const figuresGamesConfig = {
  component: Menu,
  props: () => ({
    path: pages.menu_figures,
    navigationRoute: 'showFigureGames',
    fromRoute: pages.menu_numbers,
    menuItems: [
      { label: 'Dobókocka pöttyök 6-ig', link: '/game?type=diceTo6' },
      { label: 'Arab-dobókocka 6-ig', link: '/game?type=arabicDice6' },
      { label: 'Dominó pöttyök 9-ig', link: '/game?type=diceTo9' },
      { label: 'Arab-dominó 9-ig', link: '/game?type=arabicDice9' },
      { label: 'Római számok 10-ig', link: '/game?type=roman10' },
      { label: 'Római számok-dominó pöttyökkel 9-ig', link: '/game?type=romanDice9' },
      { label: 'Szám típusa szerint vegyes', link: '/game?type=numbers' }
    ]
  })
};

const gameConfig = {
  component: GameTable,
  props: route => ({ GameType: route.query.type })
};

const routes = [
  {
    path: '/',
    name: 'Root',
    ...mainMenuConfig
  },
  {
    path: `/${pages.menu}`,
    name: 'Main menu',
    ...mainMenuConfig
  },
  {
    path: `/${pages.menu_colors}`,
    name: 'Color games',
    ...colorGamesConfig
  },
  {
    path: `/${pages.menu_letters}`,
    name: 'Letter games',
    ...letterGamesConfig
  },
  {
    path: `/${pages.menu_numbers}`,
    name: 'Number games',
    ...numberGamesConfig
  },
  {
    path: `/${pages.menu_numbers_multipliers}`,
    name: 'Multiplier games',
    ...multiplierGamesConfig
  },
  {
    path: `/${pages.menu_figures}`,
    name: 'Figure games',
    ...figuresGamesConfig
  },
  {
    path: `/${pages.rules}`,
    name: 'Rules',
    component: Rules
  },
  {
    path: `/${pages.game}`,
    name: 'Game',
    ...gameConfig
  }
];

const router = new VueRouter({
  routes
});

export default router;
